import { Spinner as BootstrapSpinner } from "react-bootstrap";

interface SpinnerProps {
  className?: string;
  size?: "sm" | undefined;
  animation?: "border" | "grow";
}

function Spinner({
  className,
  size = "sm",
  animation = "border",
  ...props
}: SpinnerProps) {
  return (
    <BootstrapSpinner
      animation={animation}
      size={size}
      className={className}
      {...props}
    />
  );
}

export { Spinner };
